export default __webpack_public_path__ + "static/media/aeropuerto.a5b1550a.jpg";